import { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import api, { num, money, formatApiError } from "@/lib/api";
import { Card, PageHeader, Btn, KPICard, StatusBadge, EmptyState, Th, Td } from "@/components/admin/ui";

export default function Payments() {
  const [data, setData] = useState({ items: [], total: 0, summary: {} });
  const [selected, setSelected] = useState([]);

  const load = useCallback(() => { api.get("/payments?limit=50").then((r) => setData(r.data)).catch(() => {}); }, []);
  useEffect(() => { load(); }, [load]);

  const toggle = (id) => setSelected((s) => s.includes(id) ? s.filter((x) => x !== id) : [...s, id]);
  const markPaid = async () => {
    if (!selected.length) return toast.error("Select transactions first");
    try { await api.post("/payments/update", { earning_ids: selected, status: "paid" }); toast.success(`${selected.length} marked paid`); setSelected([]); load(); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };

  const s = data.summary || {};
  return (
    <div className="space-y-6">
      <PageHeader title="Payments" subtitle="Worker earnings & payout management"
        action={<Btn data-testid="mark-paid-btn" onClick={markPaid} disabled={!selected.length}>Mark {selected.length || ""} Paid</Btn>} />
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <KPICard label="Approved" value={money(s.approved || 0)} accent="#10B981" />
        <KPICard label="Pending" value={money(s.pending || 0)} accent="#F59E0B" />
        <KPICard label="Processing" value={money(s.processing || 0)} accent="#3B82F6" />
        <KPICard label="Paid" value={money(s.paid || 0)} accent="#06B6D4" />
      </div>
      <Card>
        {data.items.length === 0 ? <EmptyState title="No earnings yet" desc="Earnings generated from tasks, leads and sales will appear here." /> : (
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="border-b border-white/10"><tr><Th></Th><Th>Txn ID</Th><Th>Worker</Th><Th>Source</Th><Th>Amount</Th><Th>Status</Th><Th>Date</Th></tr></thead>
              <tbody>
                {data.items.map((e) => (
                  <tr key={e.id} className="border-b border-white/5 hover:bg-white/[0.02]" data-testid={`payment-row-${e.transaction_id}`}>
                    <Td><input type="checkbox" checked={selected.includes(e.id)} onChange={() => toggle(e.id)} data-testid={`pay-check-${e.transaction_id}`} /></Td>
                    <Td className="font-mono-metric text-slate-400 text-xs">{e.transaction_id}</Td>
                    <Td className="text-slate-300">{e.worker_id}</Td>
                    <Td className="capitalize">{e.source}</Td>
                    <Td className="font-mono-metric text-emerald-400">{money(e.normalized_amount)}</Td>
                    <Td><StatusBadge status={e.status} /></Td>
                    <Td className="text-slate-500 text-xs">{e.created_at?.slice(0, 10)}</Td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Card>
    </div>
  );
}
